import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../context/LanguageContext';

const LegalContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing.xxl} ${({ theme }) => theme.spacing.md};
`;

const LegalTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  color: ${({ theme }) => theme.colors.primary};
  position: relative;
  padding-bottom: ${({ theme }) => theme.spacing.sm};
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100px;
    height: 3px;
    background-color: ${({ theme }) => theme.colors.accent};
  }
`;

const LastUpdate = styled.p`
  font-style: italic;
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  color: ${({ theme }) => theme.colors.text};
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  margin-top: ${({ theme }) => theme.spacing.xl};
  margin-bottom: ${({ theme }) => theme.spacing.md};
  color: ${({ theme }) => theme.colors.primary};
`;

const SectionContent = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.text};
  
  p {
    white-space: pre-line;
    margin-bottom: ${({ theme }) => theme.spacing.md};
  }
`;

const LegalNotice = () => {
  const { t } = useLanguage();
  const currentDate = new Date().toLocaleDateString();
  
  // Sections des mentions légales
  const sections = [
    'hotelInfo',
    'hosting',
    'intellectualProperty',
    'cookies',
    'disclaimer',
    'links'
  ];
  
  return (
    <LegalContainer>
      <LegalTitle>{t('legalNotice.title')}</LegalTitle>
      <LastUpdate>{t('legalNotice.lastUpdate', { date: currentDate })}</LastUpdate>
      
      {sections.map(section => (
        <div key={section}>
          <SectionTitle>{t(`legalNotice.sections.${section}.title`)}</SectionTitle>
          <SectionContent>
            <p>{t(`legalNotice.sections.${section}.content`)}</p>
          </SectionContent>
        </div>
      ))}
    </LegalContainer>
  );
};

export default LegalNotice;
